const HomeLayout               = () => import('@/layouts/HomeLayout')
const Login                    = () => import('@/pages/login')
// Admin pages
const AdminACL                 = () => import('@/pages/admin/acl/index')
const AdminUsers               = () => import ('@/pages/admin/users/index')
const AdminUserCreate          = () => import ('@/pages/admin/users/create')
const AdminUserEdit            = () => import ('@/pages/admin/users/edit')
const AdminCompanies           = () => import ('@/pages/admin/companies/index');
//const AdminCompaniesEdit           = () => import ('@/pages/admin/companies/edit'); // Route редактирования информации компаний

// Home pages
const Home                     = () => import ('@/pages/home/index')
const HomeCompanies            = () => import ('@/pages/home/companies/index')
const HomeCars                 = () => import ('@/pages/home/cars/index')
const HomeReservedCars         = () => import ('@/pages/home/cars/reserved')
const HomeDriversIndex         = () => import ('@/pages/home/drivers/index')
const HomeDriversQueue         = () => import ('@/pages/home/drivers/queue')
const HomeCarsDefects          = ()  => import ('@/pages/home/cars/defect_acts')
const HomeCarsRequest          = ()  => import ('@/pages/home/requests/index')
const HomeSto                  = ()  => import ('@/pages/home/requests/sto')
const HomeArchive              = ()  => import ('@/pages/home/requests/archived')
const HomeSold                 = ()  => import ('@/pages/home/cars/sold')

// Company pages
const CompanyHome              = () => import ('@/pages/company/index');
const CompanyDashboard         = () => import ('@/pages/company/home/dashboard'); // Рабочий стол компании
const CompanyCars              = () => import ('@/pages/company/cars/index'); // Страница всех автомобилей компании
const CompanyCarsInRepair      = () => import ('@/pages/company/cars/inRepair'); // Страница всех автомобилей на ремонте
const CompanyUsers             = () => import ('@/pages/company/users/index'); // Страница всех пользователей компании
const CompanySoldCars          = () => import ('@/pages/company/cars/sold'); // Страница проданных автомобилей компании
const CompanyActOfReconciliation  = () => import ('@/pages/company/act_of_reconciliation/index'); // Страница акта сверки
const CompanyCarsCard          = () => import ('@/pages/company/cars/card');
const CompanyCarsCreate        = () => import ('@/pages/company/cars/create');
const CompanyCarsEdit          = () => import ('@/pages/company/cars/edit');
const CompanyDrivers           = () => import ('@/pages/company/drivers/index');
const CompanyDriversCreate     = () => import ('@/pages/company/drivers/create')
const CompanyDriversEdit       = () => import ('@/pages/company/drivers/edit')
const CompanyDriversCard       = () => import ('@/pages/company/drivers/card')
const CompanyStoRequests       = () => import ('@/pages/company/requests/index')
const CompanyRepairRequests    = () => import ('@/pages/company/requests/repair')
const CompanyActiveRequests    = () => import ('@/pages/company/requests/repair')
const CompanyArchivedRequests  = () => import ('@/pages/company/requests/archived')
const CompanyDefectAct         = () => import ('@/pages/company/defect_act/index')
const CompanyDoneAct           = () => import ('@/pages/company/done_acts/index')
const CompanyActIndex          = () => import ('@/pages/company/rt_act/index')
const CompanyUnConfirmedActs   = () => import ('@/pages/company/unConfirmedActs')

// STO pages
const StoLayout                = () => import ('@/pages/sto/index')
const StoHome                  = () => import ('@/pages/sto/home/index')
const StoRequests              = () => import ('@/pages/sto/requests/index')
const StoCompanies             = () => import ('@/pages/sto/companies/index')
const StoCompany               = () => import ('@/pages/sto/companies/company')
const StoCompanyEdit           = () => import ('@/pages/sto/companies/edit')
const StoPricelist             = () => import ('@/pages/sto/pricelist/index')
const StoServices              = () => import ('@/pages/sto/services/index')
const StoDefects               = () => import ('@/pages/sto/defects/index')
const StoCarCard               = () => import ('@/pages/sto/companies/cars/card')
const StoCarCreate             = () => import ('@/pages/sto/companies/cars/create')
const StoRepairRequests        = () => import ('@/pages/sto/requests/repair')
const StoRTActIndex            = () => import ('@/pages/sto/rt_act/index')
const StoRTAct                 = () => import ('@/pages/sto/rt_act/crud')
const StoMastersIndex          = () => import ('@/pages/sto/masters/index')
const StoMastersCreate         = () => import ('@/pages/sto/masters/create')
const StoMastersEdit           = () => import ('@/pages/sto/masters/edit')
const StoCreateRTAct           = () => import ('@/pages/sto/rt_act/create')
const StoEditRTAct             = () => import ('@/pages/sto/rt_act/edit')
const StoCreateDefectAct       = () => import ('@/pages/sto/defect_act/create')
const StoReCreateDefectAct     = () => import ('@/pages/sto/defect_act/create')
const StoDefectAct             = () => import ('@/pages/sto/defect_act/index')
const StoDoneAct               = () => import ('@/pages/sto/done_acts/index')
const StoRepairedCars          = () => import ('@/pages/sto/repaired_cars/index')
const StoAcceptedCars          = () => import ('@/pages/sto/accepted_cars/index')
const StoTurningCars           = () => import ('@/pages/sto/turning_cars/index')
const StoActOfReconciliation   = () => import ('@/pages/sto/act_of_reconciliation/index'); // Страница акта сверки
const StoCounterparties        = () => import ('@/pages/sto/counter_parties/index'); // Страница контрагентов

const Signature                = () => import ('@/pages/sto/rt_act/signature')

// Error pages
const NotFound                 = () => import ('@/pages/errors/404')
const NoAccess                 = () => import ('@/pages/errors/403')

const routes = [
    { path: '/login', name: 'Login', component: Login },
    { path: '/403', name: 'NoAccess', component: NoAccess },
    { path: '/404', name: 'NotFound', component: NotFound },
    // Home layout
    { path: '/', component: HomeLayout, meta: { requiresAuth: true },
        children: [
            // Admin routes
            { path: '/a/acl', name: 'AdminACL', component: AdminACL,
                meta: {
                    requiresAuth: true,
                    permissions: ['read-acl'],
                    type: 'admin'
                },
            },
            { path: '/a/users', name: 'AdminUsers', component: AdminUsers,
                meta: {
                    requiresAuth: true,
                    permissions: ['read-users'],
                    type: 'admin'
                }
            },
            { path: '/a/users/create', name: 'AdminUserCreate', component: AdminUserCreate,
                meta: {
                    requiresAuth: true,
                    permissions: ['create-users'],
                    type: 'admin'
                }
            },
            { path: '/a/users/edit/:id', name: 'AdminUserEdit', component: AdminUserEdit,
                meta: {
                    requiresAuth: true,
                    permissions: ['update-users'],
                    type: 'admin'
                }
            },
            { path: '/a/companies', name: 'AdminCompanies', component: AdminCompanies,
                meta: {
                    requiresAuth: true,
                    permissions: ['read-companies'],
                    type: 'admin'
                }
            },
            // Route редактирование информации компании
            // { path: '/a/companies/edit/:id', name: 'AdminCompaniesEdit', component: AdminCompaniesEdit,
            //     mete:{
            //         requiresAuth: true,
            //         type: 'admin'
            //     },
            // },

            // Home routes
            { path: '/', name: 'Home', component: Home, meta: { requiresAuth: true, type: 'home' } },
            { path: '/companies', name: 'HomeCompanies', component: HomeCompanies, meta: { requiresAuth: true, type: 'home' } },
            { path: '/cars', name: 'HomeCars', component: HomeCars, meta: { requiresAuth: true, type: 'home' } },
            { path: '/cars/reserved', name: 'HomeReservedCars', component: HomeReservedCars, meta: { requiresAuth: true, type: 'home' } },
            { path: '/drivers', name: 'HomeDriversIndex', component: HomeDriversIndex, meta: { requiresAuth: true, type: 'home' } },
            { path: '/drivers/queue', name: 'HomeDriversQueue', component: HomeDriversQueue, meta: { requiresAuth: true, type: 'home' } },
            { path: '/cars/defects', name: 'HomeCarsDefects', component: HomeCarsDefects, meta: { requiresAuth: true, type: 'home' } },
            { path: '/request', name: 'HomeCarsRequest', component: HomeCarsRequest, meta: { requiresAuth: true, type: 'home' } },
            { path: '/sto', name: 'HomeSto', component: HomeSto, meta: { requiresAuth: true, type: 'home' } },
            { path: '/archive', name: 'HomeArchive', component: HomeArchive, meta: { requiresAuth: true, type: 'home' } },
            { path: '/sold-cars', name: 'HomeSold', component: HomeSold, meta: { requiresAuth: true, type: 'home' } },
        ],
    },

    // Company routes
    { path: '/c/:slug', name: 'CompanyHome', component: CompanyHome, meta: { requiresAuth: true, type: 'company' },
        children: [
            { path: 'dashboard', name: 'CompanyDashboard', component: CompanyDashboard, meta: { requiresAuth: true, type: 'company' } },
            { path: 'act-of-reconciliation', name: 'CompanyActOfReconciliation', component: CompanyActOfReconciliation, meta: { requiresAuth: true, type: 'sto' } },
            { path: 'inRepair', name: 'CompanyCarsInRepair', component: CompanyCarsInRepair, meta: { requiresAuth: true, type: 'company' } },
            { path: 'users', name: 'CompanyUsers', component: CompanyUsers, meta: { requiresAuth: true, type: 'company' } },
            { path: 'active', name: 'CompanyActiveRequests', component: CompanyActiveRequests, meta: { requiresAuth: true, type: 'company' } },
            { path: 'unConfirmedActs', name: 'CompanyUnConfirmedActs', component: CompanyUnConfirmedActs, meta: { requiresAuth: true, type: 'company' } },
            { path: 'cars', name: 'CompanyCars', component: CompanyCars, meta: { requiresAuth: true, type: 'company' } },
            { path: 'cars/:car/card', name: 'CompanyCarsCard', component: CompanyCarsCard, meta: { requiresAuth: true, type: 'company' } },
            { path: 'cars/sold', name: 'CompanySoldCars', component: CompanySoldCars, meta: { requiresAuth: true, type: 'company' } },
            { path: 'cars/create', name: 'CompanyCarsCreate', component: CompanyCarsCreate, meta: { requiresAuth: true, type: 'company' } },
            { path: 'cars/:car/edit', name: 'CompanyCarsEdit', component: CompanyCarsEdit, meta: { requiresAuth: true, type: 'company' } },
            { path: 'drivers', name: 'CompanyDrivers', component: CompanyDrivers, meta: { requiresAuth: true, type: 'company' } },
            { path: 'drivers/create', name: 'CompanyDriversCreate', component: CompanyDriversCreate, meta: { requiresAuth: true, type: 'company' } },
            { path: 'drivers/:driver/edit', name: 'CompanyDriversEdit', component: CompanyDriversEdit, meta: { requiresAuth: true, type: 'company' } },
            { path: 'drivers/:driver/card', name: 'CompanyDriversCard', component: CompanyDriversCard, meta: { requiresAuth: true, type: 'company' } },
            //{ path: 'drivers/:driver/incident', name: 'CompanyDriversIncident', component: CompanyDriversIncident, meta: { requiresAuth: true, type: 'company' } },
            { path: 'sto-list', name: 'CompanyStoRequests', component: CompanyStoRequests, meta: { requiresAuth: true, type: 'company' } },
            { path: 'requests/repair', name: 'CompanyRepairRequests', component: CompanyRepairRequests, meta: { requiresAuth: true, type: 'company' } },
            { path: 'requests/archive', name: 'CompanyArchivedRequests', component: CompanyArchivedRequests, meta: { requiresAuth: true, type: 'company' } },
            { path: 'defect-acts/:act', name: 'CompanyDefectAct', component: CompanyDefectAct, meta: { requiresAuth: true, type: 'company' } },
            { path: 'done-acts/:act', name: 'CompanyDoneAct', component: CompanyDoneAct, meta: { requiresAuth: true, type: 'company' } },
            { path: 'act-acts/:act', name: 'CompanyActIndex', component: CompanyActIndex, meta: { requiresAuth: true, type: 'company' } },
        ]
    },

    // Sto routes
    { path: '/s', name: 'StoLayout', component: StoLayout, meta: { requiresAuth: true, type: 'sto' },
        children: [
            { path: ':slug', name: 'StoHome', component: StoHome, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/c-list', name: 'StoRequests', component: StoRequests, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/act-of-reconciliation', name: 'StoActOfReconciliation', component: StoActOfReconciliation, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/counter_parties', name: 'StoCounterparties', component: StoCounterparties, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/requests/repair', name: 'StoRepairRequests', component: StoRepairRequests, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/companies', name: 'StoCompanies', component: StoCompanies, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/companies/:company', name: 'StoCompany', component: StoCompany, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/companies/edit/:id', name: 'StoCompanyEdit', component: StoCompanyEdit, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/companies/:company/cars/:car/card', name: 'StoCarCard', component: StoCarCard, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/companies/:company/cars/create', name: 'StoCarCreate', component: StoCarCreate, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/companies/:company/cars/:car/edit', name: 'StoCarsEdit', component: CompanyCarsEdit, meta: { requiresAuth: true, type: 'sto' } },

            { path: ':slug/pricelist', name: 'StoPricelist', component: StoPricelist, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/services', name: 'StoServices', component: StoServices, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/defects', name: 'StoDefects', component: StoDefects, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/rt-act/crud', name: 'StoRTAct', component: StoRTAct, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/rt-act/:act', name: 'StoRTActIndex', component: StoRTActIndex, meta: { requiresAuth: true, type: 'sto' } },

            { path: ':slug/masters', name: 'StoMastersIndex', component: StoMastersIndex, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/masters-create', name: 'StoMastersCreate', component: StoMastersCreate, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/master/:master/edit', name: 'StoMastersEdit', component: StoMastersEdit, meta: { requiresAuth: true, type: 'sto' } },

            { path: ':slug/companies/:company/cars/:car/card/rt-act/create', name: 'StoCreateRTAct', component: StoCreateRTAct, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/companies/:company/cars/:car/card/rt-act/:act/edit', name: 'StoEditRTAct', component: StoEditRTAct, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/companies/:company/cars/:car/card/defect-act/create', name: 'StoCreateDefectAct', component: StoCreateDefectAct, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/companies/:company/cars/:car/card/defect-act/:act/:tag', name: 'StoReCreateDefectAct', component: StoReCreateDefectAct, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/defect-act/:act', name: 'StoDefectAct', component: StoDefectAct, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/done-act/:act', name: 'StoDoneAct', component: StoDoneAct, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/repaired-cars', name: 'StoRepairedCars', component: StoRepairedCars, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/accepted-cars', name: 'StoAcceptedCars', component: StoAcceptedCars, meta: { requiresAuth: true, type: 'sto' } },
            { path: ':slug/inturn-cars', name: 'StointurnCars', component: StoTurningCars, meta: { requiresAuth: true, type: 'sto' } },

            { path: ':slug/signature/:act', name: 'Signature', component: Signature, meta: { requiresAuth: true, type: 'sto' } },

        ]
    }
];

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js